
























import Vue from "vue";

import Menu from "@/components/navigation/Menu.vue";

export default Vue.extend({
  name: "Dashboard",
  components: {
    Menu
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: true
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    },
    username() {
      return this.$store.state.auth.auth.userInfo.firstName;
    },
    initial() {
      return this.$store.state.auth.auth.userInfo.firstName.charAt(0);
    }
  }
});
